// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "688a84d-dirty",
    "hash": "688a84d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "688a84d-dirty",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
